import { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  legend?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  isLoading?: boolean;
  className?: string;
}

/**
 * ChartCard - Reusable card wrapper for chart components
 * Provides consistent styling, title area, legend, and action buttons
 */
const ChartCard = ({ 
  title, 
  subtitle, 
  legend, 
  actions, 
  children, 
  isLoading,
  className = ''
}: ChartCardProps) => {
  if (isLoading) {
    return (
      <div className={`bg-slate-900/50 backdrop-blur-sm p-4 sm:p-6 rounded-2xl shadow-lg border border-slate-800 animate-pulse h-80 ${className}`}>
      </div>
    );
  }

  return (
    <div className={`bg-slate-900/50 backdrop-blur-sm p-4 sm:p-6 rounded-2xl shadow-lg border border-slate-800 ${className}`}>
      <div className="flex flex-row items-center justify-between mb-6 gap-2">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-white">
            {title} {subtitle && <span className="font-normal text-slate-400">({subtitle})</span>}
          </h3>
          {legend && (
            <div className="flex items-center gap-4 mt-1">
              {legend}
            </div>
          )}
        </div>
        {actions && (
          <div className="flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default ChartCard;
